import React from 'react';

import { Box, Button, Checkbox, Grid, List, ListItemButton as ListItem, ListItemText, Stack, Typography } from '@mui/material';


import { Chart } from "react-google-charts";

import * as Api from "api/api"
import * as AdminAPi from "api/admin"


export default function DashboardTab() {

    const mounted = React.useRef(false);
    const [dataRequested, setDataRequested] = React.useState(false);
    //let [dataStatusCode, setDataStatusCode] = React.useState(0);
    const [errorMessage, setErrorDashboardData] = React.useState<string | null>(null);
    let [dashboardData, setDashboardData] = React.useState<AdminAPi.ApiDashboard | null>(null);
    //let [tableData, setTableData] = useState([])

    let [showSpecimenDetails, setShowSpecimenDetails] = React.useState(false);
    let [selectedSpecimenIndex, setSelectedSpecimenIndex] = React.useState(0);
    const [soldOutState, setSoldOutState] = React.useState(false);
    const soldOutStateRef = React.useRef(false);

    const handleLangChange = React.useCallback((event) => {

        if (event.target.id === 'soldOut') {
            setSoldOutState(event.target.checked);
            soldOutStateRef.current = event.target.checked;
            setDataRequested(false)
        }

    }, []);


    React.useEffect(() => {
        mounted.current = true;
        if (!dataRequested) {
            Api.requestAdmin<AdminAPi.ApiDashboard>('dashboard', 'get', {}).then(dashboardData => {
                if (mounted.current) {
                    //console.log(dashboardData)
                    setDashboardData(dashboardData);
                }
            }).catch(err => {
                setErrorDashboardData(err.message);
            });
            setDataRequested(true)
            return;
        }
        return () => { mounted.current = false }
    }, [dataRequested]);


    React.useEffect(() => {
        Api.requestAdmin<any>('dashboard', 'cards_sold_out', { soldOutStateMsg: soldOutStateRef.current === true ? 'true' : 'false' }).then(dashboardData => {
            setDataRequested(false)
        }).catch(err => {
            setErrorDashboardData(err.message);
        });
        setDataRequested(true)
    }, [soldOutState]);




    // TODO: loading
    if (!dashboardData) {
        return <></>;
    }
    // console.log(dashboardData.users.total)

    return <>

        <Stack direction='column' height='100%' alignItems='center' spacing={2}>
            {/* <ItemName>Users:</ItemName><ItemValue>{dashboardData.users.total}</ItemValue>
            <ItemName>Cards:</ItemName><ItemValue>{dashboardData.cards.total}</ItemValue> */}

            {/* <Grid item xs={11}><ActivityChart /></Grid> */}
            <Typography>Total Users: {dashboardData.users.total}</Typography>
            <Typography>Paid but not complete: {dashboardData.paidNotCompleteCards.paidNotCompleteTotal}</Typography>
            <Typography>Produce but not issued: {dashboardData.produceNotIssuedCards.produceNotIssuedTotal}</Typography>
            {/* <Typography>Total Users: {dashboardData.products.isSoldOut}</Typography> */}

            <Box sx={{ display: 'flex', alignItems: 'center' }}>

                <Checkbox
                    id="soldOut"
                    name="eng"
                    onChange={handleLangChange}
                    checked={dashboardData.products.isSoldOut}
                />
                <Typography>Sold Out</Typography>

            </Box>

        </Stack>
    </>
}

